/**
 * The gallery's rows: the shared view-rows request at the gallery's address.
 *
 * A gallery is never grouped -- the endpoint takes no `group_by` and the view
 * type offers none -- so there is no metadata to carry beyond the rows and the
 * count.
 */
import { viewRowsFetcher } from '../views/view-rows'

const gallery = viewRowsFetcher('/api/database/views/gallery/{view_id}/')

export const fetchGalleryRows = gallery.fetch
export const __setGalleryRowFetcherForTests = gallery.setForTests
